module.exports = __webpack_public_path__ + "static/media/address-icon.1335de6f.svg";